export enum MessageDisplayType {
    ClosedAutomatically,
    ClosedManually,
    Failure,
    Success,
}
